import { createAction } from 'typesafe-actions';

export const purchase = createAction('PRODUCT/PURCHASE')<void>();
export const productPriceInfoListUpdated = createAction('PRODUCT/PRODUCT_PRICE_INFO_LIST_UPDATED')<void>();
